import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import AllPromotions from "./AllPromotions";
import ActivePromotions from "./ActivePromotions";
import { useLocation } from "react-router";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../../constants/AppConstants";

const PromotionsTab = () => {
  const { getUserPermission:activePromotionsPermissions} = usePermissionGetter(
    permissionsConstants.promotions,
    permissionsConstants.active_promotions
  );
  const { getUserPermission:allPromotionsPermissions} = usePermissionGetter(
    permissionsConstants.promotions,
    permissionsConstants.all_promotions
  );
  const [tab, setTab] = React.useState("allPromotions");
    const [tabList,setTabList]= useState<string[]>([])
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  const { search } = useLocation();
  useEffect(() => {
    if (
      allPromotionsPermissions("read") &&
      !tabList.includes("allPromotions")
    ) {
      setTabList((prevTabList) => [...prevTabList, "allPromotions"]);
    }
    if (
      activePromotionsPermissions("read") &&
      !tabList.includes("activePromotions")
    ) {
      setTabList((prevTabList) => [...prevTabList, "activePromotions"]);
    }
  }, [allPromotionsPermissions, activePromotionsPermissions]);

  useEffect(() => {
    if (tabList[0] !== undefined && tab !== tabList[0]) setTab(tabList[0]);
  }, [tabList]);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const tabId = query.get("tab");
    if (tabId) setTab(tabId);
  }, []);

  return (
    <Grid sx={{ background: theme.color?.background, borderRadius: "16px" }}>
      <Grid borderBottom={theme.border?.smallGrey} px={4} py={5}>
        <Typography
          sx={{
            fontWeight: theme.font?.fontWeight.thick,
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
          }}
        >
          Promotions
        </Typography>
      </Grid>
      <Grid
        item
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        sx={{ background: theme.color?.background, width: "100%" }}
      >
        <Box ml={3}>
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: theme.color?.secondary,
              },
            }}
            value={tab}
            onChange={handleChange}
            aria-label="tabs menu"
          >
            {allPromotionsPermissions("read") && (
              <Tab
                value={"allPromotions"}
                id={"allPromotions"}
                label="All Promotions"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "allPromotions"
                      ? theme.color?.secondary
                      : undefined,
                }}
              />
            )}
            {activePromotionsPermissions("read") && (
              <Tab
                value={"activePromotions"}
                id={"activePromotions"}
                label="Active Promotions"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "activePromotions"
                      ? theme.color?.secondary
                      : undefined,
                }}
              />
            )}
          </Tabs>
        </Box>
      </Grid>
      <Grid px={4} py={2}>
        {tab === "allPromotions" ? <AllPromotions /> : <ActivePromotions />}
      </Grid>
    </Grid>
  );
};

export default PromotionsTab;
